import actionTypes from './actionTypes';
import type { IRateEngineVersion, ISubmitRequestPayload, ParsedErrorMap } from './types';

const actions = {
  loadVersionRequest: (id: string) => ({ type: actionTypes.LOAD_VERSION_REQUEST, payload: { id } }),
  loadVersionSuccess: (version: IRateEngineVersion) => ({
    type: actionTypes.LOAD_VERSION_SUCCESS,
    payload: { version },
  }),
  // `requestedId` lets the reducer tell a failed re-read of the held version from a failed load of a
  // different one — only the latter may drop what is loaded.
  loadVersionError: (message: string, requestedId?: string | null) => ({
    type: actionTypes.LOAD_VERSION_ERROR,
    payload: { error: message, requestedId: requestedId ?? null },
  }),
  clearLoadedVersion: () => ({ type: actionTypes.CLEAR_LOADED_VERSION }),

  submitRequest: (payload: ISubmitRequestPayload) => ({
    type: actionTypes.SUBMIT_REQUEST,
    payload,
  }),
  submitSuccess: (version: IRateEngineVersion) => ({
    type: actionTypes.SUBMIT_SUCCESS,
    payload: { version },
  }),
  submitFailed: (parsedErrors: ParsedErrorMap = {}) => ({
    type: actionTypes.SUBMIT_FAILED,
    payload: { parsedErrors },
  }),

  setParsedErrors: (parsedErrors: ParsedErrorMap) => ({
    type: actionTypes.SET_PARSED_ERRORS,
    payload: { parsedErrors },
  }),
  clearSubmitErrors: () => ({ type: actionTypes.CLEAR_SUBMIT_ERRORS }),
  clearStore: () => ({ type: actionTypes.CLEAR_STORE }),
};

export default actions;
